import React, { useRef, useEffect } from "react";
// import { useSelector  , useDispatch  } from "react-redux";
import { useTheme } from "react-jss";
import classnames from "classnames";
import useStyles from "./ButtonChoice.styles";
import { RadioIcon } from "./RadioIcon";
import { CheckBoxIcon } from "./CheckBoxIcon";
// import { setDefaultFocusStatus } from "../../redux/actions/index";
// import { StoreState } from "../../models/states/StoreState";
// import { DefaultFocusStatus } from "../../models/states/DefaultFocusStatus";
import { VariableModel } from "../../models/VariableModel";
import useQuestion from "../../hooks/useQuestion";
import {
    getAriaLabelledByFromId,
    useAriaLabelledByForQuestionOpenEndChoiceBox,
} from "../../utils/WCAGHelper";

interface Props {
    id?: string;
    choiceElementId?: string;
    type: "checkbox" | "radio";
    label?: string;
    className?: string;
    disabled?: boolean;
    selected?: boolean;
    hasOpenEnd?: boolean;
    openEndSize?: string;
    horizontal?: boolean;
    onSelect?(): void;
    onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
    renderChoice?(): any;
    renderAfter?(): any;
    carrouselChoiceBackgound?: string;
    variable?: VariableModel;
}

export function ButtonChoice(props: Props) {
    const {
        id,
        choiceElementId,
        disabled,
        label,
        type,
        className,
        hasOpenEnd,
        openEndSize,
        horizontal,
        selected,
        onSelect,
        onKeyDown,
        renderChoice,
        renderAfter,
        carrouselChoiceBackgound,
        // variable,
    } = props;

    const question = useQuestion();
    const [hover, setHover] = React.useState(false);
    const [active, setActive] = React.useState(false);
    const useAriaLabelledBy = useAriaLabelledByForQuestionOpenEndChoiceBox(question);

    const theme = useTheme() as any;
    const classes = useStyles({
        theme,
        selected,
        hasOpenEnd,
        openEndSize,
        horizontal,
        carrouselChoiceBackgound,
        type,
    });

    const ChoiceIcon = type === "radio" ? RadioIcon : CheckBoxIcon;
    // const dispatch = useDispatch();
    const elementReference = useRef(null);
    // const defaultFocusStatus = useSelector(
    //     (state: StoreState) => state.defaultFocusStatus,
    // ) as DefaultFocusStatus;
    // function setFocusToCurrentElement() {
        // Disabling the below code on a temporary basis as per the ticket DEV-78236 since as of now this behaviour only implemented
        // for radio button question type which is making the respondents inconvience when we have questions
        // other than radio button type in the page.
        // const elementToFocus = elementReference.current;
        // if (elementToFocus.scrollIntoView) {
        //     elementToFocus.scrollIntoView(true);
        // }
        // elementToFocus.focus();
    // }
    useEffect(() => {
        // Temporarily rolled back due to DEV-90066: Surveys freezing when taken on mobile (NA4 - 6.12 - S2)

        // if (variable && defaultFocusStatus && defaultFocusStatus.statuses) {
        //     const focusStatus = defaultFocusStatus.statuses.find((element) => {
        //         return element.focusStatus;
        //     });
        //     const currentElementStatus = defaultFocusStatus.statuses.find((element) => {
        //         return element.elementId === id && element.variableId === variable.id;
        //     });
        //     if (!focusStatus && !currentElementStatus) {
        //         defaultFocusStatus.statuses.push({
        //             elementId: id,
        //             elementRef: elementReference,
        //             variableId: variable.id,
        //             focusStatus: true,
        //         });
        //         dispatch(setDefaultFocusStatus(defaultFocusStatus));
        //         setFocusToCurrentElement();
        //     } else if (focusStatus && !currentElementStatus) {
        //         defaultFocusStatus.statuses.push({
        //             elementId: id,
        //             elementRef: elementReference,
        //             variableId: variable.id,
        //             focusStatus: false,
        //         });
        //         dispatch(setDefaultFocusStatus(defaultFocusStatus));
        //     } else if (!focusStatus && currentElementStatus) {
        //         const index = defaultFocusStatus.statuses.indexOf(currentElementStatus);
        //         defaultFocusStatus.statuses[index].focusStatus = true;
        //         dispatch(setDefaultFocusStatus(defaultFocusStatus));
        //         setFocusToCurrentElement();
        //     }
        // }
    }, []);

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            id={id}
            role={type}
            ref={elementReference}
            aria-checked={selected}
            {...(useAriaLabelledBy
                ? { "aria-labelledby": getAriaLabelledByFromId(question, choiceElementId) }
                : { "aria-label": label })}
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            tabIndex={0}
            onFocus={() => setActive(true)}
            onBlur={() => setActive(false)}
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            onKeyDown={onKeyDown}
            onMouseDown={(e) => {
                const div = e.target as HTMLDivElement;
                const activeElement = document.activeElement as HTMLElement;
                if (!div.contains(activeElement)) activeElement.blur();
                e.preventDefault();
            }}
            onClick={() => {
                onSelect();
                document.getElementById(id).focus();
            }}
            className={classnames(
                classes.choice,
                ...([className] || []),
                hover && classes.choiceHover,
                active && classes.choiceActive,
                selected && classes.choiceSelected,
            )}
        >
            <div className={classes.choiceContainer}>
                {renderChoice ? (
                    renderChoice()
                ) : (
                    <>
                        <ChoiceIcon checked={selected} disabled={disabled} hover={hover} />
                        {theme.DisplayChoiceIcon !== "none" && (
                            <span className={classes.spacer} aria-hidden="true" />
                        )}
                        <span
                            className={classes.choiceText}
                            id={id}
                            dangerouslySetInnerHTML={{ __html: label }}
                        />
                    </>
                )}
            </div>
            {renderAfter && renderAfter()}
        </div>
    );
}
